import React from 'react';
import { ERegion } from '@opu/utils';
import { Col, Card } from 'shards-react';
import Table from '../UI/Table/Table';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { EstablishmentContracts } from '../../views/contract/listContractByEstablishment';
import Modal from '../UI/modal/Modal';
import './style.css';

export default function Est({ displayOptions }) {
  const [establishementId, setEstablishmentId] = React.useState('');
  const [query, setQuery] = React.useState({ page: null, keyword: '', limit: 10, region: 'est' });
  const { t } = useTranslation();
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = React.useState(false);
  const handleOpen = (establishmentId) => {
    setEstablishmentId(establishmentId);
    setIsDetailsModalOpen(true);
  };
  const { attributes, actions, getEstablishmentByRegion } = useForm({ detailsAction: true }, handleOpen);

  const getData = () => {
    setLoading(true);
    getEstablishmentByRegion(query)
      .then((res) => {
        setData({
          region: ERegion.Est,
          listEstablishment: res.data.items,
          totalPages: res.data.totalPages,
          totalItems: res.data.totalItems,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error({ error });
        Swal.fire(t('contract.ERROR_GET_CONTRACTS'), '', 'error');
        setLoading(false);
      });
  };
  React.useEffect(() => {
    getData();
  }, [query]);
  return (
    <>
      <Modal
        open={isDetailsModalOpen}
        setOpen={setIsDetailsModalOpen}
        body={<EstablishmentContracts establishmentId={establishementId} />}
        className="details-modal"
      />

      <Col>
        <Card small className="mb-4">
          <Table
            title={ERegion.Est}
            attributes={attributes}
            actions={actions}
            data={data?.listEstablishment}
            loading={loading}
            search={getEstablishmentByRegion}
            numberOfPage={data?.totalPages}
            query={query}
            setQuery={setQuery}
            textButton={displayOptions.addButton && t('contract.add')}
            linkButton={displayOptions.addButton && '/contract/add'}
            pdfTitle="Liste des Etablissements - EST"
          />
        </Card>
      </Col>
    </>
  );
}
